import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

const useBrowserBackStack = () => {
  const history = useHistory();
  const [backStack, setBackStack] = useState([]);

  useEffect(() => {
    const unlisten = history.listen((location, action) => {
      setBackStack((prevBackStack) => {
        switch (action) {
          case 'POP':
            // If there's only one entry in the backStack, return it
            if (prevBackStack.length <= 1) return [location];
            // If there are more than one, return the last three entries
            return prevBackStack.slice(-3);
          case 'PUSH':
            // Add the new location to the end of the backStack
            return [...prevBackStack.slice(-2), location];
          case 'REPLACE':
            // Replace the last entry in the backStack with the new location
            return [...prevBackStack.slice(0, -2), location];
          default:
            return prevBackStack;
        }
      });
    });

    return () => {
      unlisten();
    };
  }, [history]);

  return backStack;
};

export default useBrowserBackStack;
